// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"048a3b2b","156":"e8d0ac42","453":"64bf80f6","582":"27bea16b","775":"b4d7fd26","823":"cae31a4e","885":"83833a08"}[chunkId] + ".chunk.js";
};